export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export type Pagination = {
  limit: number | undefined; // setting as undefined instead of optional to ensure value is intentionally set.
  offset: number;
};

export type Sort = {
  field?: string;
  order?: SortOrder;
};

export enum ComparisonOperatorsKeys {
  EQUAL = "$eq",
  NOT_EQUAL = "$ne",
  GREATER_THAN = "$gte",
  LESSER_THAN = "$lte",
  IN = "$in",
  EXISTS = "$exists",
  REGEX = "$regex",
}

export type ComparisonOperators<T> = {
  [ComparisonOperatorsKeys.EQUAL]?: T;
  [ComparisonOperatorsKeys.NOT_EQUAL]?: T;
  [ComparisonOperatorsKeys.GREATER_THAN]?: number;
  [ComparisonOperatorsKeys.LESSER_THAN]?: number;
  [ComparisonOperatorsKeys.IN]?: T[];
  [ComparisonOperatorsKeys.EXISTS]?: boolean;
  [ComparisonOperatorsKeys.REGEX]?: T;
};

export type SearchParamValue = string | string[] | undefined;
export type SearchParams = Record<string, SearchParamValue>;

export interface FormattedDate {
  date: string;
  time: string;
}

export interface KeyValuePair {
  key: string;
  value: string;
}

export type CurrencyType = string;

export enum ParseDateKeys {
  START = "start",
  END = "end",
}

export type ParseDateComparison = {
  [ParseDateKeys.START]?: number;
  [ParseDateKeys.END]?: number;
};

export enum ParseNumberKeys {
  MIN = "min",
  MAX = "max",
  UNIT = "unit",
}

export type ParseNumberComparison = {
  [ParseNumberKeys.MIN]?: number;
  [ParseNumberKeys.MAX]?: number;
  [ParseNumberKeys.UNIT]?: string;
};
